import request from '@core/services/request';

export const customersAPI = {
	getApplicantsListPaged: (customerRequest: any) => {
		return request.post(`/Customer/GetApplicantsListPaged`, customerRequest);
	},
	getCustomersLeadsListPaged: (customerRequest: any) => {
		return request.post(`/Customer/GetCustomersLeadsListPaged`, customerRequest);
	},
	getCustomersListPaged: (customerRequest: any, isModalView: any, includeCustomerWithoutAplication: any) => {
		return request.post(
			`/Customer/GetCustomersListPaged?isModalView=${isModalView}&includeCustomerWithoutAplication=${includeCustomerWithoutAplication}`,
			customerRequest,
		);
	},
	saveLead: (lead: any) => request.post(`/Customer/SaveLead`, lead),
	saveCustomer: (customer: any) => request.post(`/Customer/SaveCustomer`, customer),
	createCustomerFromFIMenu: (fimenuCustomer: any, storeCode: any, source: any, dealDate: any = null) =>
		request.post(`/Customer/CreateCustomerFromFIMenu`, {
			customer: fimenuCustomer,
			storeCode,
			source,
			dealDate,
		}),
	saveCustomerFromFIMenu: (fimenuCustomer: any) => request.post(`/Customer/SaveCustomerFromFIMenu`, fimenuCustomer),
	getCustomerById: (id: any) => request.get(`/Customer/GetCustomer?customerId=${id}`),
	getCustomerContactInfo: (customerId: any) => request.get(`/Customer/GetCustomerContactInfo?customerId=${customerId}`),
	getAssociatedCustomersForBusiness: (id: any) => request.get(`/Customer/GetAssociatedCustomersForBusiness?id=${id}`),
	getAssociatedBusinessesForCustomer: (customerId: any) => request.get(`/Customer/GetAssociatedBusinessesForCustomer?customerId=${customerId}`),
};
